import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
*, ::before, ::after{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
html, body,#root{
    height: 100%;
    overflow-x: hidden;
}
html{
    font-family: 'Inter', 'Montserrat', sans-serif;
    scroll-behavior: smooth;
    font-size: 16px;
}
a{
    text-decoration: none;
    color: inherit;
    transition: all 0.3s ease;
}
body.dark{
    --heading-text: #f0f0f0;
    --primary-text: #e8e8fd;
    --secondary-text: #a0a0a0;
    --nav-text: #b0b7ff;
    --nav-text-active: #ffffff;
    --primary-background: #121212;
    --secondary-background: #1e1e1e;
    --button-background: #4a5bef;
    --button-hover-background: #3949d8;
    --icon-color: #8a96ff;
    --icon-hover: #ffffff;
    --box-shadow: rgba(0, 0, 0, 0.4);
    --loading-bar-bg: #4a5bef;
    --vibrant: #4a5bef;
    --cursor-color: #fff;
    --cursor-inner-color: #000;
    --card-background: #1e1e1e;
    --border-color: #2d2d2d;
}
body.light{
    --heading-text: #1a1a2e;
    --primary-text: #2a2a3a;
    --secondary-text: #5a5a6a;
    --nav-text: #4a5bef;
    --nav-text-active: #1a1a2e;
    --primary-background: #f8fafc;
    --secondary-background: #ffffff;
    --button-background: #4a5bef;
    --button-hover-background: #3949d8;
    --icon-color: #4a5bef;
    --icon-hover: #3949d8;
    --box-shadow: rgba(100, 100, 111, 0.1);
    --loading-bar-bg: #4a5bef;
    --vibrant: #4a5bef;
    --cursor-color: #000;
    --cursor-inner-color: #fff;
    --card-background: #ffffff;
    --border-color: #e5e7eb;
    .bg{
        opacity: 0.9;
    }
}
body{
    background-color: var(--primary-background);
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    transition: background-color 0.5s ease, color 0.5s ease;
    color: var(--primary-text);
    line-height: 1.6;
    font-weight: 400;
}
h1, h2, h3, h4, h5, h6 {
    color: var(--heading-text);
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 1rem;
}
p {
    margin-bottom: 1rem;
}
button, input[type='submit']{
    outline: none;
    border: none;
    background: var(--button-background);
    color: white;
    cursor: pointer;
    border-radius: 8px;
    padding: 0.75rem 1.5rem;
    font-weight: 600;
    font-size: 1rem;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
button:hover, input[type='submit']:hover {
    background: var(--button-hover-background);
    transform: translateY(-2px);
    box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}
button:active, input[type='submit']:active {
    transform: translateY(1px);
}
input, textarea {
    padding: 0.75rem;
    border-radius: 8px;
    border: 1px solid var(--border-color);
    background: var(--secondary-background);
    color: var(--primary-text);
    font-family: 'Inter', 'Montserrat', sans-serif;
    transition: all 0.3s ease;
}
input:focus, textarea:focus {
    outline: none;
    border-color: var(--vibrant);
    box-shadow: 0 0 0 2px rgba(74, 91, 239, 0.2);
}
.scrollbar-track{
    background-color: transparent !important;
}
.scrollbar-thumb{
    background-color: var(--vibrant) !important;
    border-radius: 8px;
}
section {
    padding: 5rem 0;
}
.container {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
}
.card {
    background-color: var(--card-background);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 30px -15px var(--box-shadow);
    transition: all 0.3s ease;
}
.card:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 30px -15px var(--box-shadow);
}
.section-title {
    font-size: 2.5rem;
    margin-bottom: 2rem;
    position: relative;
    display: inline-block;
}
@media (max-width: 768px) {
    html {
        font-size: 14px;
    }
    .section-title {
        font-size: 2rem;
    }
    section {
        padding: 3rem 0;
    }
}
`;
export default GlobalStyles;
